import { AdvancedSelect } from '@orobix/orobix-fe-components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type SelectOption = {
  value: string
  label: string
}

const getOption = (
  options: SelectOption[],
  value?: boolean
): SelectOption | undefined => {
  if (value === true) return options.find((o) => o.value === 'correct')
  if (value === false) return options.find((o) => o.value === 'error')
  return undefined
}

const IsCorrectFilter = ({
  initialValue,
  onChange,
}: {
  initialValue?: boolean
  onChange: (v: SelectOption | null) => void
}) => {
  const { t } = useTranslation()

  const options = [
    { label: t('Match'), value: 'correct' },
    { label: t('Mismatch'), value: 'error' },
  ]

  const [value, setValue] = useState<SelectOption | undefined>(
    getOption(options, initialValue)
  )

  return (
    <AdvancedSelect
      name="isCorrectFilter"
      id="isCorrectFilter"
      value={value}
      onChange={(v) => {
        setValue(v || undefined)
        onChange(v)
      }}
      options={options}
      label={t('Prediction')}
      placeholder={t('Filter...')}
      isClearable
    />
  )
}

export default IsCorrectFilter
